import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab'
import { Typography, useTheme } from '@mui/material'

import { getFormattedDateTime } from '../../utils/helpers'

import useStyles from './index.styles'

interface IOrderTimeline {
  event: string
  eventTime: string
  color?: 'success' | 'error' | 'warning' | undefined
}

const expectedOrderTimeline = ['Submitted', 'Fulfilled', 'Shipped', 'Delivered']
const expectedReturnTimeline = ['Return Created', 'Received', 'Received in Full']
const expectedReorderTimeline = ['Submitted', 'Ordered']

// REVIEW: this is "functional" but maybe dumb.
// possibly come up with a different idea to show incomplete statuses but also show statuses that aren't expected
const getFormattedTimeline = (expectedTimeline: string[], actualTimeline: IOrderDetail['events']) => {
  let unexpectedStatus = false

  // REVIEW: do we need to sort by timestamp later?
  const timeline = actualTimeline.map((actual, idx) => {
    const actualIsExpected = expectedTimeline.includes(actual.event)
    const inTheRightOrder = expectedTimeline.findIndex((val) => val === actual.event) === idx

    let color: IOrderTimeline['color']
    if (actual.eventTime && actualIsExpected) color = 'success'
    if (actual.eventTime && !actualIsExpected) color = 'error'

    if (!inTheRightOrder) unexpectedStatus = true

    return {
      ...actual,
      color,
    } satisfies IOrderTimeline
  })

  // if the timeline is out of order in anyway, just return it
  if (unexpectedStatus) return timeline

  const actualValues = actualTimeline.map((actual) => actual.event)
  const missingTimelineItems = expectedTimeline.filter((expectedValue) => !actualValues.includes(expectedValue))

  // add the missing expected values to the end of the list of actual values
  return timeline.concat(
    missingTimelineItems.map(
      (missing) =>
        ({
          event: missing,
          eventTime: '',
          color: undefined,
        }) satisfies IOrderTimeline
    )
  )
}

const OrderTimeline = ({ events, orderType }: { events: IOrderDetail['events']; orderType: OrderType }) => {
  const classes = useStyles
  const theme = useTheme()

  const cleanEvents = events.map((e) => {
    try {
      return { ...e, event: JSON.parse(e.event) }
    } catch {
      return e
    }
  }) // Cleans up double-quote issue
  const expectedTimeline = orderType === 'reorder' ? expectedReorderTimeline : orderType === 'return' ? expectedReturnTimeline : expectedOrderTimeline
  const timeline = getFormattedTimeline(expectedTimeline, cleanEvents)

  return (
    <Timeline sx={classes.timeline}>
      {cleanEvents.length === 0 ? (
        <Typography variant="caption">Timeline currently unavailable</Typography>
      ) : (
        timeline.map((s, idx) => {
          const isCompleted = !!s.eventTime

          return (
            <TimelineItem key={idx}>
              <TimelineSeparator>
                <TimelineDot variant={isCompleted ? 'filled' : 'outlined'} color={isCompleted ? s.color : undefined} />
                {idx < timeline.length - 1 && <TimelineConnector />}
              </TimelineSeparator>
              <TimelineContent sx={{ ...(!isCompleted ? classes.dateMissing(theme) : {}) }}>
                <Typography variant="overline" sx={classes.summaryFieldTitle} component="div">
                  {s.event}
                </Typography>
                <Typography variant="caption">{isCompleted && getFormattedDateTime(s.eventTime)}</Typography>
              </TimelineContent>
            </TimelineItem>
          )
        })
      )}
    </Timeline>
  )
}

export default OrderTimeline
